import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import EmailForm from './EmailForm';
import LearningInfo from './LearningInfo';
import PwForm from './PwForm';
import { TYPE, URL } from '../../../../constant';
import MyPageHeader from './MyPageHeader';
import { useUserInfo } from '../../../../hooks';
import GlobalMyPageHeader from '../../../global/mypage/GlobalMyPageHeader';

function MyPage() {
  const history = useHistory();
  const { info } = useUserInfo();

  const handleLogout = useCallback(() => {
    history.push(URL.ACCOUNT.LOGIN);
  }, [])
  
  return (
    <React.Fragment>
      {info.channelCode === TYPE.CHANNEL.GM_APP && <MyPageHeader />}
      {info.channelCode === TYPE.CHANNEL.GLOBAL01 && <GlobalMyPageHeader />}
      
      <div className="layout-def layout-sl bg_gray">
        <div className="container">
          <div className="inner">
            <div className="wirte_form lr gm">
              <section className="w672 w672_tb">
                {/* <form> */}
                <h2>회원정보</h2>
                <EmailForm />
                <PwForm />
                {/* </form> */}
              </section>
              <section className="no_border">
                <LearningInfo />
              </section>
              <div className="logout w672 w672_tb">
                <button
                  className="btn btn-white"
                  onClick={handleLogout}
                >로그아웃</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default MyPage;